import React, { Component } from "react";
import { Link } from "react-router-dom";
import QVFourPhotoSection from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourSecondPage/QVFourPhotoSection";
import QVFourPresentedByFooter from "views/Pma/PmaEditor/ThirdPageComponents/QVFourPresentedByFooter";
import AgentLogoHeader from "views/Pma/PmaEditor/ThirdPageComponents/AgentLogoHeader";
import QVFourPS from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourSecondPage/QVFourPS";
import MQThreeAvailableHomes from "views/Pma/PmaEditor/ThirdPageComponents/MQThreeAvailableHomes";
import QRCode from "views/Pma/PmaEditor/ThirdPageComponents/QRCode";
import MarketIndicators from "views/Pma/PmaEditor/YearEnd2022/YETwo/YETwoSecondPage/YETwoMarketIndicators";
import QVFourEmailAndWebsiteFooter from "views/Pma/PmaEditor/SecondPageComponents/QVFourEmailAndWebsiteFooter";
import MiniTablePro from "views/PmaAdmin/MiniTablePro";
import ColorHotBoxes from "views/Pma/PmaEditor/SecondPageComponents/ColorHotBoxes";
import MissionStatementBlock from "views/Pma/PmaEditor/ThirdPageComponents/MissionStatementBlock";
import CallToActionFooter from "views/Pma/PmaEditor/ThirdPageComponents/CallToActionFooter";
import BottomHotBoxes from "views/Pma/PmaEditor/ThirdPageComponents/BottomHotBoxes";
import { renderLogicUtil } from "views/Pma/RenderLogicUtil";
import { noteUtils } from "views/Pma/MailPro/components/Notes/Common/NoteUtils";
import {
  MaxAllowedLinesInNote,
  perLineComfortableNoteCharCount,
} from "views/Pma/MailPro/components/Notes/Common/NotesConfig";

class StandardTableAH extends Component {
  sortByStatus = (propList, getExtendedTable, alwaysExtendedTable) => {
    const { mlsAreaID } = this.props.currentArea;
    const { listgenUserID } = this.props.agentData;

    const sortByStatusAndPrice = (arr) => {
      const convertToNumber = (price) => {
        if (!price || price === "-" || price === "") return 0;
        const cleaned = String(price).replace(/,/g, "").trim();
        const num = parseFloat(cleaned);
        return isNaN(num) ? 0 : num;
      };

      const soldProps = arr.filter((prop) => prop.status === "Sold");
      const activeProps = arr.filter((prop) => prop.status === "Active");
      const pendingAndContingentProps = arr.filter(
        (prop) => prop.status === "Pending" || prop.status === "Contingent",
      );

      const sortedSoldProps = soldProps.sort((a, b) => {
        const priceA = convertToNumber(a.salePrice);
        const priceB = convertToNumber(b.salePrice);
        return priceB - priceA;
      });

      const sortedActiveProps = activeProps.sort((a, b) => {
        const priceA = convertToNumber(a.listPrice);
        const priceB = convertToNumber(b.listPrice);
        return priceB - priceA;
      });

      const sortedPendingAndContingentProps = pendingAndContingentProps.sort(
        (a, b) => {
          const priceA = convertToNumber(a.listPrice);
          const priceB = convertToNumber(b.listPrice);
          return priceB - priceA;
        },
      );

      let soldIndex = 0;
      let activeIndex = 0;
      let pendingContingentIndex = 0;

      return arr.map((prop) => {
        if (prop.status === "Sold") {
          return sortedSoldProps[soldIndex++];
        } else if (prop.status === "Active") {
          return sortedActiveProps[activeIndex++];
        } else if (prop.status === "Pending" || prop.status === "Contingent") {
          return sortedPendingAndContingentProps[pendingContingentIndex++];
        }
        return prop;
      });
    };

    let {
      activePhotoDetailsList,
      contingentPhotoDetailsList,
      pendingPhotoDetailsList,
      preSoldPhotoDetailsList,
      recentSoldPhotoDetailsList,
      agentFilteredPhotoDetailsList,
      comingSoonSoldPhotoDetailsList,
    } = this.props.quarterlyAreaTable;

    const filterOutProperties = (dataList) => {
      return dataList;
      // }
    };

    let sold = recentSoldPhotoDetailsList
      ? filterOutProperties(recentSoldPhotoDetailsList)
      : [];
    let pend = pendingPhotoDetailsList
      ? filterOutProperties(pendingPhotoDetailsList)
      : [];
    let cont = contingentPhotoDetailsList
      ? filterOutProperties(contingentPhotoDetailsList)
      : [];
    let comingSoonList = [];

    let active = activePhotoDetailsList
      ? filterOutProperties(activePhotoDetailsList)
      : [];
    let laterSold = preSoldPhotoDetailsList
      ? filterOutProperties(preSoldPhotoDetailsList)
      : [];
    let agentsProps = agentFilteredPhotoDetailsList
      ? filterOutProperties(agentFilteredPhotoDetailsList)
      : [];

    let last45DaysSum =
      (agentFilteredPhotoDetailsList
        ? filterOutProperties(agentFilteredPhotoDetailsList).length
        : 0) +
      (activePhotoDetailsList
        ? filterOutProperties(activePhotoDetailsList).length
        : 0) +
      (contingentPhotoDetailsList
        ? filterOutProperties(contingentPhotoDetailsList).length
        : 0) +
      (pendingPhotoDetailsList
        ? filterOutProperties(pendingPhotoDetailsList).length
        : 0) +
      (recentSoldPhotoDetailsList
        ? filterOutProperties(recentSoldPhotoDetailsList).length
        : 0);

    let remainderPreSold = 12 - last45DaysSum;

    const sortStartingJan1 = (data) => {
      // Filter sold properties starting from January 1, 2025

      let soldFromJan1 = data
        .filter((x) => x.status === "Sold")
        .filter((x) => {
          if (x.saleDate === "-" || !x.saleDate) return false;
          const saleDate = new Date(x.saleDate);
          let currentYear = new Date().getFullYear();
          const jan1_2025 = new Date(`${currentYear}-01-01`);
          return saleDate >= jan1_2025;
        })
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));
      // Get non-sold properties (Active, Coming Soon, Pending, Contingent)
      let nonSoldProps = data.filter((x) => x.status !== "Sold");
      // Combine non-sold properties with sold properties from Jan 1, 2025
      let combined = [...nonSoldProps, ...soldFromJan1];
      // Remove duplicates
      let uniqueProps = combined.filter(
        (obj1, i, arr) =>
          arr.findIndex(
            (obj2) =>
              obj2.streetNumber === obj1.streetNumber &&
              obj2.streetName === obj1.streetName &&
              obj2.status === obj1.status &&
              obj2.streetSuffix === obj1.streetSuffix &&
              obj2.unitNumber === obj1.unitNumber &&
              obj2.squareFeet === obj1.squareFeet,
          ) === i,
      );
      let updatedList = [...uniqueProps];

      let onlyActivePendingContingent = updatedList.filter(
        (prop) =>
          prop.status === "Active" ||
          prop.status === "Active - Coming Soon" ||
          prop.status === "Coming Soon" ||
          prop.status === "Active - Contingent" ||
          prop.status === "Pending" ||
          prop.status === "Contingent",
      );

      return [
        ...onlyActivePendingContingent,
        ...onlySoldProps,
        ...onlyAgentProps,
      ];
    };
    const sortByStatusThenDate = (data) => {
      let sortedSolds = data
        .filter((x) => x.status === "Sold")
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));

      let newConstructed = [
        ...data.filter(
          (x) =>
            x.status === "Active - Coming Soon" || x.status === "Coming Soon",
        ),
        ...data.filter((x) => x.status === "Active"),
        ...data.filter((x) => x.status === "Active - Contingent"),
        ...data.filter(
          (x) => x.status === "Pending" || x.status === "Contingent",
        ),
        ...sortedSolds,
      ];

      let uniqueProps = newConstructed.filter(
        (obj1, i, arr) =>
          arr.findIndex(
            (obj2) =>
              obj2.streetNumber === obj1.streetNumber &&
              obj2.streetName === obj1.streetName &&
              obj2.status === obj1.status &&
              obj2.streetSuffix === obj1.streetSuffix &&
              obj2.unitNumber === obj1.unitNumber &&
              obj2.squareFeet === obj1.squareFeet,
          ) === i,
      );
      return uniqueProps;
    };
    let extraProperties;

    const sortByStatusThenPropType = (data) => {
      let singleFamHomes = data
        .filter(
          (x) => x.status === "Sold" && x.propertyType === "Single Family Home",
        )
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));
      let townhomeSolds = data
        .filter((x) => x.status === "Sold" && x.propertyType === "Townhouse")
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));
      let sortedSolds = [...singleFamHomes, ...townhomeSolds];
      let newConstructed = [
        ...data.filter(
          (x) =>
            x.status === "Active" ||
            x.status === "Active - Coming Soon" ||
            x.status === "Coming Soon",
        ),
        ...data.filter((x) => x.status === "Active - Contingent"),
        ...data.filter(
          (x) => x.status === "Pending" || x.status === "Contingent",
        ),
        ...sortedSolds,
      ];
      let uniqueProps = newConstructed.filter(
        (obj1, i, arr) =>
          arr.findIndex(
            (obj2) =>
              obj2.streetNumber === obj1.streetNumber &&
              obj2.streetName === obj1.streetName &&
              obj2.status === obj1.status,
          ) === i,
      );
      return uniqueProps;
    };
    let trueSort1 = [
      ...agentsProps,
      ...active,
      ...pend,
      ...cont,
      ...sold,
      ...laterSold.slice(0, remainderPreSold),
    ];

    if (comingSoonList && comingSoonList.length > 0) {
      trueSort1 = [
        ...comingSoonList,
        ...agentsProps,
        ...active,
        ...pend,
        ...cont,
        ...sold,
        ...laterSold.slice(0, remainderPreSold),
      ];
    }

    let extendedTrueSortJan1 = [
      ...comingSoonList,
      ...agentsProps,
      ...active,
      ...pend,
      ...cont,
      ...sold,
      ...laterSold,
    ];

    let trueSort = sortByStatusThenDate(trueSort1);

    if (last45DaysSum < 12 || alwaysExtendedTable) {
      if (getExtendedTable) {
        return false;
      } else {
        return trueSort;
      }
    } else {
      let today = new Date();
      let date45DaysAgo = new Date(
        today.setDate(today.getDate() - 45),
      ).toISOString();
      let last45DayDates = trueSort.filter(
        (x) =>
          (x.saleDate !== "-" && x.saleDate > date45DaysAgo) ||
          x.status === "Active" ||
          x.status === "Active - Coming Soon" ||
          x.status === "Contingent" ||
          x.status === "Pending",
      );
      let remainderExtended = 18 - last45DayDates.length;
      let extendedTrueSort1 = [
        ...agentsProps,
        ...active,
        ...pend,
        ...cont,
        ...sold,
        ...laterSold.slice(0, remainderExtended),
      ];

      let extendedTrueSort;

      extendedTrueSort = sortByStatusThenDate(extendedTrueSort1.slice(0, 14));

      if (getExtendedTable) {
        return true;
      } else {
        let extendedResult = extendedTrueSort.slice(
          0,
          extraProperties ? extraProperties : 12,
        );
        return extendedResult;
      }
    }
    // return propList.slice(0, 19);
  };

  render() {
    const {
      currentArea,
      agentData,
      printVersion,
      fromEditor,
      version,
      hoData,
      mlsAreas,
      demoAccountHOName,
      quarterlyAreaTable,
      quarterlyCityTable,
      propertyData,
      MQCityDetails,
      isDemo,
      missionStatement,
      miniTableDetailsDTO,
      coverPageDetails,
      fromThirdPage,
      showAllEditButtons,
    } = this.props;
    const { changeDetails, propertyDetails } = hoData || {};
    const globalPSCreationDate =
      currentArea && currentArea.globalNoteCurrentDateTime
        ? currentArea.globalNoteCurrentDateTime
        : null;
    const globalNoteShowHideLogic =
      renderLogicUtil.checkGlobalNoteShowHideLogic(
        globalPSCreationDate,
        changeDetails,
        propertyDetails,
      );
    const { personalPSHistory } = changeDetails
      ? changeDetails
      : propertyDetails
        ? propertyDetails
        : {};
    const anyPersonalNoteAddedinCurrentMailing =
      renderLogicUtil.getCurrentMailingPersonalNote(
        personalPSHistory,
        this.props.lastPMAPrintDate,
        "",
        false,
      );
    const { globalNoteCurrent } = currentArea || {};
    let hoTextNote = "Stay tuned for your next PMA!";

    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;
    let { currentSoldListings } = quarterlyAreaTable;
    let useExtendedTable = false;
    let useHotBoxes = false;
    let useSeparatedPropertyTypesCondoTownhouse = false;
    if (mlsAreaID === "xSMA-390") {
      useSeparatedPropertyTypesCondoTownhouse = true;
      useHotBoxes = true;
    } else if (mlsAreaID === "SMA-392") {
      // single family market indicators (no separated property types)
      useHotBoxes = true;
    }

    let useCondosOnly = false;

    let useTownhousesOnly = false;

    let sorted =
      currentSoldListings && currentSoldListings
        ? this.sortByStatus(currentSoldListings, false, useExtendedTable)
        : [];

    let useCity = false;
    if (mlsAreaID === "SBA-40F" || mlsAreaID === "SBA-40G") {
      useCity = true;
    }
    let showAvailableHomes = true;
    let showBottomHotBoxes = false;
    const miniTableMaxRowsLimit = 12;
    //if miniTableMaxRows is more than 12, then showAvailableHomes is false and showBottomHotBoxes is false
    if ((miniTableDetailsDTO?.miniTableMaxRows || 0) > miniTableMaxRowsLimit) {
      showAvailableHomes = false;
      showBottomHotBoxes = false;
    }
    if (mlsAreaID === "CCA-4500R") {
      showAvailableHomes = false;
    }
    let useForNovember = false;
    let showMiniTable = true;

    let useMissionStatement = false;

    let useCallToActionFooter = false;

    if (listgenUserID === "109954") {
      showBottomHotBoxes = false;
      showAvailableHomes = false;
    }

    if (
      !globalNoteShowHideLogic.showGlobalNote &&
      anyPersonalNoteAddedinCurrentMailing &&
      anyPersonalNoteAddedinCurrentMailing.note
    ) {
      hoTextNote = anyPersonalNoteAddedinCurrentMailing.note;
    } else if (
      changeDetails &&
      changeDetails.textPS &&
      changeDetails.textPS.length > 1
    ) {
      hoTextNote = changeDetails.textPS;
    } else if (globalNoteCurrent && globalNoteCurrent.length > 1) {
      hoTextNote = globalNoteCurrent;
    }
    const hoTextNoteLineCount = noteUtils.countLineBreaksInHtmlNote(
      hoTextNote,
      perLineComfortableNoteCharCount,
    );

    let moveQRAndTableDown = false;
    if (hoTextNoteLineCount > 5) {
      moveQRAndTableDown = false;
    }
    let totalAreaActivesFromTable = miniTableDetailsDTO.miniTable.filter(
      (x) => x.status === "Active",
    ).length;
    let showQRCode = true;
    if (mlsAreaID === "CCA-4500R") {
      showQRCode = false;
    }
    if (useForNovember) {
      return (
        <div
          className={`${
            version === "year-end-2022" ? "ye2" : "qv4"
          }-second-right`}
        >
          <ColorHotBoxes
            printVersion={printVersion}
            currentArea={currentArea}
            quarterlyAreaTable={quarterlyAreaTable}
            agentData={agentData}
            quarterlyCityTable={quarterlyCityTable}
          />
          {showMiniTable && (
            <>
              {/* MiniTablePro - miniTableDetailsDTO.miniTable sliced to 12 in index; only miniTableDetailsID passed down */}
              <MiniTablePro
                currentArea={currentArea}
                quarterlyAreaTable={quarterlyAreaTable}
                propertyData={propertyData}
                hoData={hoData}
                agentData={agentData}
                printVersion={!fromEditor} //printVersion && fromEditor
                fromEditor={fromEditor}
                miniTableDetailsDTO={miniTableDetailsDTO}
                useExtendedTable={useExtendedTable}
                tableMonthStyles="november-table-container"
                fromThirdPage={fromThirdPage}
                showAllEditButtons={showAllEditButtons}
              />
            </>
          )}

          {useHotBoxes && (
            <MarketIndicators
              quarterlyAreaTable={quarterlyAreaTable}
              currentArea={currentArea}
              useCity={useCity}
              printVersion={printVersion}
              quarterlyCityTable={quarterlyCityTable}
              agentData={agentData}
              useSecondMarketIndicators={true}
              useSeparatedPropertyTypesCondoTownhouse={
                useSeparatedPropertyTypesCondoTownhouse
              }
              useSeparatedPropertyTypesCondos={useCondosOnly}
              useSeparatedPropertyTypesTownhouses={useTownhousesOnly}
              from3rdPage={false}
            />
          )}

          <QVFourEmailAndWebsiteFooter
            agentData={agentData}
            currentArea={currentArea}
            printVersion={printVersion}
          />
        </div>
      );
    } else {
      return (
        <div
          className={`${
            version === "year-end-2022" ? "ye2" : "qv4"
          }-second-right`}
        >
          <AgentLogoHeader
            agentData={agentData}
            currentArea={currentArea}
            printVersion={printVersion}
            fromEditor={fromEditor}
          />
          {fromEditor && showAllEditButtons && (
            <Link
              to={`/mailpro/${mlsAreaID}`}
              style={{
                position: "absolute",
                right: "-279px",
                top: "128px",
                backgroundColor: "#4e85af",
                color: "white",
                padding: "8px 16px",
                textDecoration: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              <p>Go to MailPro to Edit Global Note</p>
            </Link>
          )}

          {hoData &&
            hoData.changeDetails &&
            Object.keys(hoData.changeDetails).length > 1 && (
              <QVFourPS
                agentData={agentData}
                hoData={hoData}
                currentArea={currentArea}
                mlsAreas={mlsAreas}
                version={version}
                printVersion={printVersion}
                mailingNum="qv4"
                demoAccountHOName={demoAccountHOName}
                isDemo={isDemo}
              />
            )}
          {showQRCode && (
            <QRCode
              hoData={hoData}
              agentData={agentData}
              currentArea={currentArea}
              printVersion={printVersion}
              moveQRAndTableDown={moveQRAndTableDown}
            />
          )}

          {useMissionStatement ? (
            <MissionStatementBlock
              printVersion={printVersion}
              fromEditor={fromEditor}
              missionStatement={missionStatement}
              agentData={agentData}
              currentArea={currentArea}
              showAllEditButtons={showAllEditButtons}
            />
          ) : listgenUserID === "x" ? (
            <QVFourPhotoSection
              currentArea={currentArea}
              agentData={agentData}
              printVersion={printVersion}
              version={version}
              hoData={hoData}
              currentSoldListings={quarterlyAreaTable.currentSoldListings}
            />
          ) : (
            <MiniTablePro
              currentArea={currentArea}
              quarterlyAreaTable={quarterlyAreaTable}
              propertyData={propertyData}
              hoData={hoData}
              agentData={agentData}
              printVersion={!fromEditor} //printVersion && fromEditor
              fromEditor={fromEditor}
              miniTableDetailsDTO={miniTableDetailsDTO}
              useExtendedTable={useExtendedTable}
              tableMonthStyles="november-table-container"
              moveQRAndTableDown={moveQRAndTableDown}
              fromThirdPage={fromThirdPage}
              showAllEditButtons={showAllEditButtons}
            />
          )}

          {!useExtendedTable &&
            !useHotBoxes &&
            showAvailableHomes &&
            !useMissionStatement &&
            !showBottomHotBoxes && (
              <MQThreeAvailableHomes
                currentArea={currentArea}
                quarterlyAreaTable={quarterlyAreaTable}
                quarterlyCityTable={quarterlyCityTable}
                MQCityDetails={MQCityDetails}
                hoData={hoData}
                agentData={agentData}
                useCity={useCity}
                printVersion={printVersion}
                totalAreaActivesFromTable={totalAreaActivesFromTable}
              />
            )}
          {useHotBoxes && (
            <MarketIndicators
              quarterlyAreaTable={quarterlyAreaTable}
              currentArea={currentArea}
              useCity={useCity}
              printVersion={printVersion}
              quarterlyCityTable={quarterlyCityTable}
              agentData={agentData}
              useSecondMarketIndicators={true}
              useSeparatedPropertyTypesCondoTownhouse={
                useSeparatedPropertyTypesCondoTownhouse
              }
              useSeparatedPropertyTypesCondos={useCondosOnly}
              useSeparatedPropertyTypesTownhouses={useTownhousesOnly}
              from3rdPage={true}
            />
          )}
          {useCallToActionFooter && (
            <CallToActionFooter
              printVersion={printVersion}
              agentData={agentData}
            />
          )}
          {showBottomHotBoxes && (
            <BottomHotBoxes
              currentArea={currentArea}
              quarterlyAreaTable={quarterlyAreaTable}
              quarterlyCityTable={quarterlyCityTable}
              printVersion={printVersion}
              agentData={agentData}
            />
          )}
          <QVFourPresentedByFooter
            agentData={agentData}
            currentArea={currentArea}
            currentSoldListings={currentSoldListings}
            printVersion={printVersion}
            coverPageDetails={coverPageDetails}
          />
        </div>
      );
    }
  }
}

export default StandardTableAH;
